export default __webpack_public_path__ + "cf0013d6ba6882861af58b4bed77bc18.svg";